/** Icon + text pill for the meta row of detail heroes (date, location,
 *  duration, episode count, …). Sits on the dark hero banner — hence the
 *  fixed white/60 icon tint. */
export function MetaPill({
  Icon,
  children,
}: {
  Icon: React.ComponentType<{ className?: string; "aria-hidden"?: boolean }>;
  children: React.ReactNode;
}) {
  return (
    <span className="inline-flex items-center gap-1.5">
      <Icon className="size-4 text-white/60" aria-hidden />
      {children}
    </span>
  );
}
